import { BusBody } from "./BusBody";
import { BUS } from "./dimensions";
import { BUS_6_LAYOUT, BUS_6_WHEELS } from "./wheels";
const bus6Preset = {
  id: "bus-6",
  silhouette: "bus",
  renderModelKey: "bus",
  renderLayoutKey: "bus-6-wheel-v1",
  label: "2 axles, single steer and dual drive",
  layout: BUS_6_LAYOUT,
  wheels: BUS_6_WHEELS,
  camera: {
    position: [12.4, 5.4, 11.2],
    target: [0, 1.7, 0],
    minDistance: 8,
    maxDistance: 34,
    fov: 32
  },
  stage: { extent: BUS.length, contactHeight: 1.4 },
  skeleton: "frame",
  Body: BusBody
};
export {
  bus6Preset
};
